import PropTypes from "prop-types";
import { useState } from "react";
import UploadOneShowFile from "./common/upload-one-show-file";
import { UPLOAD_FILE_NAME_PREFIX } from "../../../constants/prefix";
import UploadDropzoneOne from "./common/upload-dropzone-one";
import i18n from "../../../utils/locale/i18n";

function InputUpload({
  name,
  register,
  value,
  setValue,
  fieldOptions,
  control,
}) {
  const [deleteFile, setDeleteFile] = useState(false);

  const handleFilesChange = (files) => {
    setValue(name, "");
    setValue(`${name}${UPLOAD_FILE_NAME_PREFIX}`, files);
  };

  const onDelete = () => {
    setDeleteFile(true);
    setValue(name, "");
  };

  const undoDelete = () => {
    setDeleteFile(false);
    setValue(name, value);
    setValue(`${name}${UPLOAD_FILE_NAME_PREFIX}`, []);
  };

  return (
    <>
      <input type="hidden" value={value} {...register(name)} />
      {value && !deleteFile ? (
        <UploadOneShowFile
          onDelete={onDelete}
          fieldOptions={fieldOptions}
          value={value}
          name={name}
          control={control}
        />
      ) : (
        <UploadDropzoneOne onFilesChange={handleFilesChange} />
      )}
      {deleteFile && (
        <button
          type="button"
          className="btn btn-default btn-outline-dark"
          onClick={undoDelete}
        >
          <i className="fas fa-undo"></i>&nbsp;{i18n.t("restore_deleted_file")}
        </button>
      )}
    </>
  );
}

InputUpload.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
};

export default InputUpload;
